












































































































import { Component } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'
import { ModalFooter } from '@/components/molecules/ModalFooter'
import {
  Alert,
  AlertMessage,
  ErrorMessage,
  lendApi,
  LendCollection
} from '@/api'
import {
  alertStore,
  modalErrorStore,
  systemCodeStore,
  systemParameterStore
} from '@/utils/store-accessor'
import { PAGE_LOADING_END, PAGE_LOADING_START } from '@/config/event'
import { InputCode } from '@/components/molecules/InputCode'
import CODE_KEY from '@/config/code_key'

interface ModalReminderInputInterface {
  userId: string
  lendCollections: LendCollection[]
  onUpdated: () => void
}

interface InputItem {
  reminderMethod: {
    input: number
    errorMessage: string
  }
  reminderType: {
    input: string
    errorMessage: string
  }
  reminderName: {
    input: string
    errorMessage: string
  }
  reminderMemo: {
    input: string
    errorMessage: string
  }
}

const defaultInputItem = (): InputItem => ({
  reminderMethod: {
    input: 1,
    errorMessage: ''
  },
  reminderType: {
    input: '',
    errorMessage: ''
  },
  reminderName: {
    input: '',
    errorMessage: ''
  },
  reminderMemo: {
    input: '',
    errorMessage: ''
  }
})

@Component({
  components: {
    InputCode,
    ModalFooter
  }
})
export default class ModalReminderInput extends ComponentVue {
  dialog: boolean = false

  inputItem: InputItem = defaultInputItem()

  userId: string = ''

  lendCollections: LendCollection[] = []

  updatedCallback: () => void = () => {}

  get disabledReminderMethod(): boolean {
    return systemParameterStore.disabledReminderMethod
  }

  open(params: ModalReminderInputInterface) {
    systemCodeStore
      .fetchAllAndMergeByCodeKeys([CODE_KEY.REMINDER_TYPE_SETTING.KEY])
      .then(() => {
        systemParameterStore
          .fetchAllAndMergeByCodeKeys([CODE_KEY.REMINDER_METHOD_SETTING.KEY])
          .then(() => {
            if (!this.disabledReminderMethod) {
              this.inputItem.reminderMethod.input =
                systemParameterStore.defaultReminderMethodValue
            }
            this.inputItem.reminderType.input =
              systemParameterStore.defaultReminderTypeValue
          })
      })
    this.dialog = true

    this.userId = params.userId
    this.lendCollections = params.lendCollections
    this.updatedCallback = params.onUpdated
  }

  close() {
    this.dialog = false
    this.inputItem = defaultInputItem()
    this.userId = ''
    this.lendCollections = []
    this.updatedCallback = () => {}
  }

  async update() {
    this.$eventBus.emit(PAGE_LOADING_START)

    try {
      await lendApi.remind({
        id: this.userId,
        collections: this.lendCollections.map(collection => {
          return {
            id: collection.id,
            revision: collection.revision
          }
        }),
        reminderMethod: this.inputItem.reminderMethod.input,
        reminderType: this.inputItem.reminderType.input,
        reminderName: this.inputItem.reminderName.input,
        reminderMemo: this.inputItem.reminderMemo.input
      })

      this.updatedCallback()
      this.close()
    } catch (error) {
      if (error instanceof AlertMessage) {
        this.setErrorMessage(error.alerts, this.inputItem)
        alertStore.setItems(error.alerts)
        this.$modalAlert.open({
          modalType: 'ERROR'
        })
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalError.open()
      } else {
        console.error(error)
      }
    } finally {
      this.$eventBus.emit(PAGE_LOADING_END)
    }
  }

  setErrorMessage(alerts: Alert[], obj: any): void {
    alerts.forEach(alert => {
      if (alert.attribute === '') return false
      const key: keyof typeof obj = alert.attribute.replace(/_./g, str =>
        str.charAt(1).toUpperCase()
      ) as typeof obj
      const subKey: string = alert.subAttribute.replace(/_./g, str =>
        str.charAt(1).toUpperCase()
      )
      const splitKeys: string[] = (key as string).split('.')

      if (
        obj[key] !== undefined &&
        subKey !== '' &&
        Array.isArray(obj[key]) &&
        Object.prototype.toString
          .call(obj[key][alert.index][subKey])
          .slice(8, -1) === 'Object' &&
        (obj[key][alert.index][subKey] as any).hasOwnProperty('errorMessage')
      ) {
        ;(obj[key][alert.index][subKey] as any).errorMessage = alert.message
        return
      }

      if (
        obj[key] !== undefined &&
        Object.prototype.toString.call(obj[key]).slice(8, -1) === 'Object' &&
        (obj[key] as any).hasOwnProperty('errorMessage')
      ) {
        ;(obj[key] as any).errorMessage = alert.message
        return
      }

      if (splitKeys.length > 1 && subKey === '') {
        if (
          obj[splitKeys[0]][splitKeys[1]] !== undefined &&
          Object.prototype.toString
            .call(obj[splitKeys[0]][splitKeys[1]])
            .slice(8, -1) === 'Object' &&
          (obj[splitKeys[0]][splitKeys[1]] as any).hasOwnProperty(
            'errorMessage'
          )
        ) {
          ;(obj[splitKeys[0]][splitKeys[1]] as any).errorMessage = alert.message
        }
      }
    })
  }

  existsErrorMessage(errorMessage: string): boolean {
    return errorMessage !== ''
  }

  resetErrorMessage(obj: any): void {
    obj.errorMessage = ''
  }

  onClickPrint() {
    const element = document.getElementById('modal-reminder-input')
    if (element) {
      this.$webSocket.sendDialogScreenshotMessage(element)
    } else {
      this.$webSocket.sendScreenshotMessage()
    }
  }
}
